//@flow
import React, { useEffect } from "react";

//  $FlowFixMe
import css from "./ui-panel.module.scss";
import UIStatusBar from "./ui-statusbar";
import UIPanel from "./ui-panel";
import { useQuery, gql } from "@apollo/client";

const QUERY_STATION = gql`
  query GetStations($id: String) {
    stations(stationID: $id) {
      id
      name
      online
      hlsURL
      logoSq
      stationID
      shortDescription
      colour: themeColour
      nowFeature {
        id
        displayNowPlaying
        name
        image
        description
      }
      nowSong {
        id
        title
        artistDisplay
        artists {
          id
          image
        }
      }
    }
  }
`;

const QUERY_EPISODE = gql`
  query GetEpisode($id: String!) {
    episode(rcid: $id) {
      id
      description
      hlsURL
      feature {
        name
        tag
        id image
      }
    }
  }
`;

const SUBSCRIBE_STATION = gql`
  query SubStation($id: String) {
    stations(stationID: $id) {
      id
      name
      online
      hlsURL
      stationID
      colour: themeColour
      nowFeature {
        id
        displayNowPlaying
        name
      }
      nowSong {
        id
        title
        artistDisplay
        artists {
          id 
          image
        }
      }
    }
  }
`;

const UserInterface = (props: Object): Object => {
  const { currentSrc } = props;
  const isLive = currentSrc?.isLiveStream;

  const { error, data, subscribeToMore } = useQuery(isLive ? QUERY_STATION : QUERY_EPISODE, {
    variables: { id: currentSrc?.id },
    skip: !currentSrc || !currentSrc?.id,
  });
  useEffect(() => {
    if (isLive) {
      console.log("panel - subscribing to more")
      subscribeToMore({
        document: SUBSCRIBE_STATION,
        variables: { id: currentSrc?.id },
        skip: !currentSrc || !currentSrc.id,
        updateQuery: (prev, { subscriptionData }) => {
          console.log("panel - received sub data",subscriptionData.data)
          console.log("panel - prev data",prev)

          const n = { ...prev };
          n.stations = prev.stations?.map((s) => {
            if (s.id === subscriptionData?.data?.stations[0]?.stationID) {
              console.log("Station updated [Player]: ", s.name, " Now playing: ", subscriptionData?.data?.stations[0]?.nowSong?.title);
              return Object.assign({}, s, subscriptionData?.data?.stations[0]);
            }
            return s;
          });
          return n;
        },
      });
    }else{
      console.log("panel - not live - not subscribing")
    }
  }, [subscribeToMore,currentSrc,isLive]);

  // if (loading) return null;
  if (error) {
    console.error(error);
    // return null;
  }
  // console.log(data);

  const o = isLive ? data?.stations && data?.stations[0] : data?.episode;
  return (
    <div className={css.audioPlayer}>
      <UIPanel {...props} station={o} />
      <UIStatusBar {...props} station={o} />
    </div>
  );
};

export default UserInterface;
